import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

export function useGetBeeFreeTokenQuery({ enabled }: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['beefree-token'],
    queryFn: async () => fetchData<string>('api/email-marketing-config/get-beefree-token'),
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled,
  });
}
